import React, {FC, useContext, useState} from 'react';

export const DocumentContext = React.createContext({} as any);
export const useDocumentFilter = () => useContext(DocumentContext);

export const FilterProvider: FC = React.memo(({children}) => {
  const [sortProp, setSortProp] = useState<string>('date');
  return <DocumentContext.Provider value={{sortProp, setSortProp}}>{children}</DocumentContext.Provider>;
});
